import { useEffect, useState } from "react";
import { api, API, idr } from "../lib/api";
import { toast } from "sonner";
import { FileText, ReceiptText, Lock } from "lucide-react";

export default function MySlips() {
  const [slips, setSlips] = useState([]);

  // Tanpa .catch(), akun yang tidak terhubung ke data karyawan membuat promise
  // ini gagal tanpa penangan dan seluruh layar tertutup overlay error.
  useEffect(() => {
    api.get("/my/slips")
      .then(r => setSlips(r.data))
      .catch(e => toast.error(e?.response?.data?.detail || "Gagal memuat slip gaji"));
  }, []);

  const download = async (slipId, periode) => {
    const token = localStorage.getItem("hris_token");
    const res = await fetch(`${API}/my/slip/${slipId}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return toast.error("Gagal mengunduh slip gaji");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `SlipGaji_${periode}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-4 md:p-8 max-w-[1200px]">
      <header className="mb-8">
        <p className="text-xs font-semibold uppercase tracking-wider text-emerald-600 mb-2">Slip Gaji</p>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900">Riwayat Slip Gaji Saya</h1>
        <p className="mt-2 text-sm text-slate-500">Klik ikon download untuk unduh slip dalam format PDF.</p>
      </header>

      {slips.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-xl p-16 text-center">
          <ReceiptText className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="font-display font-semibold text-slate-900">Belum ada slip gaji</p>
          <p className="text-sm text-slate-500 mt-1">Slip gaji akan muncul setelah HR menerbitkannya.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {slips.map(s => (
            <div key={s.id} data-testid={`myslip-${s.id}`}
              className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:border-emerald-300 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Periode</p>
                  <p className="font-display text-xl font-bold text-slate-900">{s.periode}</p>
                </div>
                {s.closed_at ? (
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800"><Lock className="w-3 h-3" /> Final</span>
                ) : (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600">Draft</span>
                )}
              </div>
              <div className="space-y-1.5 text-sm border-t border-slate-100 pt-4">
                <div className="flex justify-between"><span className="text-slate-500">Bruto</span><span className="font-mono text-slate-700">{idr(s.calc.total_bruto)}</span></div>
                <div className="flex justify-between"><span className="text-slate-500">Potongan</span><span className="font-mono text-rose-700">{idr(s.calc.total_potongan)}</span></div>
                <div className="flex justify-between border-t border-slate-100 pt-2 mt-2">
                  <span className="font-semibold text-slate-900">Take Home Pay</span>
                  <span className="font-mono font-bold text-emerald-700">{idr(s.calc.thp)}</span>
                </div>
              </div>
              <button onClick={() => download(s.id, s.periode)} data-testid={`btn-dl-${s.id}`}
                className="mt-4 w-full inline-flex items-center justify-center gap-2 h-10 rounded-lg border border-slate-300 hover:bg-slate-50 text-slate-700 text-sm font-medium transition-colors">
                <FileText className="w-4 h-4" /> Download PDF
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
